import Configuracao from '../util/Configuracao';
import axios from 'axios';

class Api {
  _usuarioSso;

  constructor (usuarioSso) {
    this._usuarioSso = usuarioSso;
  }

  get configuracao () {
    return Configuracao.getConfiguracao();
  }

  getUrl (url, headers) {
    return axios.get(url, { headers: headers, responseType: 'json' });
  }

  fetch (url, method, body, headers, responseType) {
    return axios(this.getRequisicao(url, method, body, headers, responseType));
  }

  // Caso não sejam passados os headers da requisição, somente nesse caso, serão aplicados os cabeçalhos do SSO
  getRequisicao (url, method, body, headers, responseType) {
    let requisicao = {
      url: url,
      headers: headers || this.getSsoDefaultHeaders(),
      withCredentials: true,
    };

    if (responseType) {
      requisicao['responseType'] = responseType;
    }
    if (method) {
      requisicao['method'] = method;
    }
    if (body) {
      requisicao['data'] = body;
    }
    return requisicao;
  }

  getSsoDefaultHeaders () {
    if (this._usuarioSso) {
      return {
        'Authorization': 'Bearer ' + this._usuarioSso.ssoToken
      };
    }
  }
}

export default Api;
